import { render } from "./OpenShopInspect.vue?vue&type=template&id=bc650fe2&scoped=true&ts=true"
import script from "./OpenShopInspect.vue?vue&type=script&lang=ts"
export * from "./OpenShopInspect.vue?vue&type=script&lang=ts"

import "./OpenShopInspect.vue?vue&type=style&index=0&id=bc650fe2&lang=less&scoped=true"

import exportComponent from "D:\\wamp\\UF\\uf-approve-h5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc650fe2"]])

export default __exports__